export const PROJECT_IDS = {
    PIXEL_PLAY: '1',
    KITO: '2',
}

export const MOBILE_HEADER_IMAGES = {
    [PROJECT_IDS.PIXEL_PLAY]: '/img/sliderData/pixelPlayPrevSmall.png',
    [PROJECT_IDS.KITO]: '/img/sliderData/kitoPrevSmall.png',
}

export const PIXEL_PLAY_PROJECT_ID = PROJECT_IDS.PIXEL_PLAY
